import apiClient from '@/services/axios'

export async function del(courseId) {
  var response = await apiClient.delete('/courses/' + courseId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete course.')
}
